import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createButton: {
    id: 'studio.Fuqmt1',
    defaultMessage: 'Create new group',
  },
  creatingNewGroup: {
    id: 'studio.OTVgeC',
    defaultMessage: 'Creating a new group',
  },
  logo: {
    id: 'studio.foSyCj',
    defaultMessage: 'logo',
  },
  cancelLabel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  groupName: {
    id: 'studio.gL86bv',
    defaultMessage: 'Group name',
  },
  groups: {
    id: 'studio.hzmswI',
    defaultMessage: 'Groups',
  },
  error: {
    id: 'studio.VHBpyP',
    defaultMessage: 'There was a problem loading the groups.',
  },
  loading: {
    id: 'studio.FflmjG',
    defaultMessage: 'Loading groups…',
  },
  noGroups: {
    id: 'studio.jTs1N2',
    defaultMessage: 'No groups have been created yet.',
  },
  Manager: {
    id: 'studio.KQzcqr',
    defaultMessage: 'Manager',
  },
  Member: {
    id: 'studio.7L86Z5',
    defaultMessage: 'Member',
  },
});
